import { render } from "./index.vue?vue&type=template&id=0594a25c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductionDetails/RetailDetails/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0594a25c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0594a25c', __exports__)) {
    api.reload('0594a25c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=0594a25c", () => {
    api.rerender('0594a25c', render)
  })

}


export default __exports__